export const INTEGRATION_FILTER_SUPPORTED_TYPES = [
  'AWSAccount',
  'AzureActiveDirectory',
  'AzureSubscription',
  'GCPAccount',
  'Kubernetes',
];

export const CHAMELEON = {
  clientKey: process.env.CHAMELEON_CLIENT_KEY || '',
};
